import { api } from '../services/api';

export class TiposPerdidosService {
  constructor() {
    this.api = api;
  }

  async getTiposPerdidos() {
    const response = await api.get(`/site/v2/orcamento-crm/listar-tipos-perdidos`);

    return response.data;
  }
}
